<template>
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
    </div>
  </div>
  <div style="padding: 10px">
    <van-field v-model="inputForm.title" label="标题" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
    <van-field v-model="inputForm.summary" autosize label="摘要" type="textarea" readonly show-word-limit input-align="left" :border="false" rows="1"/>
    <van-field label="内容：" label-width='100px' readonly />
    <div>
      <quill-editor :content="inputForm.content" :options="editorOption" disabled></quill-editor>
    </div>
  </div>
</div>
</template>

<script>
import {quillEditor} from "vue-quill-editor";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  name: "noticeDetail",
  components: {
    quillEditor
  },
  data() {
    return {
      inputForm: {},
      urlType: '',
      editorOption: {
        modules: {
          toolbar: false,
        },
      },
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.urlType = query.urlType || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(id)

  },
  methods: {
    init(id) {
      if(this.urlType === '1') {
        this.$flow.queryById(id, '/small/wuyeSmallNotification/queryById').then(({ data }) => {
          this.inputForm = data
        }).catch(e => {
          console.log(e)
        })
      } else {
        this.$flow.queryById(id, '/small/wuyeSmallCommunityConsultation/queryById').then(({ data }) => {
          this.inputForm = data
        }).catch(e => {
          console.log(e)
        })
      }
    },
    goBack(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

</style>